export const profileShellSurfaceTypes = ["public", "owner", "directory"] as const;
export type ProfileShellSurfaceType = (typeof profileShellSurfaceTypes)[number];

export const profileShellTabIds = [
  "overview",
  "reviews",
  "portfolio",
  "services",
  "credentials",
] as const;
export type ProfileShellTabId = (typeof profileShellTabIds)[number];

export type ProfileShellTabDefinition = Readonly<{
  id: ProfileShellTabId;
  labelKey: string;
  componentInstance: string;
  publicSectionKeys: readonly string[];
}>;

export const profileShellTabs: readonly ProfileShellTabDefinition[] = [
  {
    id: "overview",
    labelKey: "profile.shellTabs.overview",
    componentInstance: "profileShellOverviewTab",
    publicSectionKeys: ["identity", "media", "about", "quick_facts", "availability", "organization"],
  },
  {
    id: "reviews",
    labelKey: "profile.shellTabs.reviews",
    componentInstance: "profileShellReviewsTab",
    publicSectionKeys: ["reputation", "recognition"],
  },
  {
    id: "portfolio",
    labelKey: "profile.shellTabs.portfolio",
    componentInstance: "profileShellPortfolioTab",
    publicSectionKeys: ["portfolio", "recognition"],
  },
  {
    id: "services",
    labelKey: "profile.shellTabs.services",
    componentInstance: "profileShellServicesTab",
    publicSectionKeys: ["services", "skills", "equipment", "team"],
  },
  {
    id: "credentials",
    labelKey: "profile.shellTabs.credentials",
    componentInstance: "profileShellCredentialsTab",
    publicSectionKeys: ["compliance", "equipment", "team"],
  },
] as const;

export function isProfileShellTabId(value: unknown): value is ProfileShellTabId {
  return typeof value === "string" && profileShellTabIds.includes(value as ProfileShellTabId);
}

export function profileShellBackLabelKey(input: Readonly<{
  surface: ProfileShellSurfaceType;
  arrivedFromDirectory?: boolean;
}>): string {
  if (input.surface === "owner") return "profile.backToHome";
  if (input.arrivedFromDirectory) return "profile.backToDirectory";
  return "profile.backToSearch";
}
